import { Button, makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import onwardColors from 'lib/onwardColors';
import ChatIcon from '../images/ChatIcon';
import ENV from '../constants/Env';
import history from '../navigation/history';

const useStyles = makeStyles(() => ({
  chatButton: {
    padding: 0,
    minWidth: 0,
    borderRadius: '50%',
  },
  fabWrapper: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    zIndex: 2000,
  },
  hidden: {
    display: 'none',
  },
  iconContainer: {
    backgroundColor: onwardColors.onwardMedPurple,
    borderRadius: '50%',
    padding: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#422357',
      cursor: 'pointer',
    },
  },
  svgIcon: {
    width: 42,
    height: 42,
    display: 'block',
  },
}));

export default function ChatButton({ onClick }) {
  const classes = useStyles();
  const [iframeModalOpen, setIframeModalOpen] = useState(false);

  // Listen for postMessage events from the iframe
  // The iframe notifies us when the MNCS modal opens or closes
  // When the modal is open, we hide the chat button to avoid
  // overlapping the modal's close / cancel button
  useEffect(() => {
    const handleMessage = event => {
      if (event.origin !== ENV.portalUrl) {
        return;
      }

      const { data } = event;

      if (data.action === 'MNCS_MODAL_OPEN') {
        setIframeModalOpen(true);
      }

      if (data.action === 'MNCS_MODAL_CLOSED') {
        setIframeModalOpen(false);
      }
    };

    window.addEventListener('message', handleMessage, false);

    return () => {
      window.removeEventListener('message', handleMessage, false);
    };
  }, []);

  // Reset iframe modal state on route change
  // The iframe does not always emit a "closed" event when the user
  // navigates away, which can leave the chat button hidden
  // Listening to navigation ensures the button becomes visible again
  useEffect(() => {
    const unlisten = history.listen(() => {
      setIframeModalOpen(false);
    });

    return () => {
      unlisten();
    };
  }, []);

  return (
    <div
      className={`${classes.fabWrapper} ${
        iframeModalOpen ? classes.hidden : ''
      }`}
    >
      <Button className={classes.chatButton} type="button" onClick={onClick}>
        <div className={classes.iconContainer}>
          <ChatIcon />
        </div>
      </Button>
    </div>
  );
}
